import { returnPaymentNotificationParameter } from "../PaymentNotificationParameterForm";
import { returnSalesNotificationParameter } from "../SalesNotificationParameterForm";
import { returnSalesPartitionParameter } from "../SalesPartitionParameterForm";

const printParameterReturnValueFunctions = {
  '3': returnSalesNotificationParameter,
  '5': returnSalesPartitionParameter,
  '6': returnPaymentNotificationParameter,
  '13': returnSalesNotificationParameter,
}

/** 入力確定時、フォームの入力値を変換する */
const returnPrintParameter = (printSetting, formValue) => {
  
  const returnValueFunction = printParameterReturnValueFunctions[printSetting.Value.reportTypeId];
  
  if (!returnValueFunction) {
    return null;
  }

  return returnValueFunction(formValue);
}

export default returnPrintParameter;